import React, { Component } from "react";
// import logo from './logo.svg';
import "./App.css";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

import AuthProvider from "./auth.js";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Writefn from "./components/written/writefn";
import BlogHome from "./Pages/Blogs/Bloghome/bloghome";
import BlogRead from "./Pages/Blogs/BlogRead/BlogRead";
import Chatbot from "./Pages/chatbot/chatbot";
import Services from "./Pages/Services/services";
import About from "./Pages/About/about";
import Category from "./Pages/Blogs/Category/Category";
import Notfound from "./components/notfound";
import Taxcal from "./Pages/Taxcal/tax";
import Tax from "./Pages/Services/TAX/Tax";
import Company from "./Pages/Services/Company/Company";

const options = {
  timeout: 5000,
  position: positions.BOTTOM_CENTER,
};

class App extends Component {
  render() {
    return (
      <Router>
        <Provider template={AlertTemplate} {...options}>
          <AuthProvider>
            <div className="App">
              <Switch>
                <Route exact path="/" component={Services} />
                <Route exact path="/blog/:slug" component={BlogRead} />
                <Route exact path="/write" component={Writefn} />
                <Route exact path="/blog" component={BlogHome} />
                <Route exact path="/services/tax" component={Tax} />
                <Route exact path="/services/company-registration" component={Company} />
                <Route exact path="/about-us" component={About} />
                <Route exact path="/kitnatax" component={Taxcal} />
                <Route exact path="/category/:cats" component={Category} />

                <Route component={Notfound} />
              </Switch>
            </div>
            <Chatbot />
          </AuthProvider>
        </Provider>
      </Router>
    );
  }
}
export default App;
